var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ComposedMenuSubMenuWithOptionalBack',{attrs:{"title":_vm.$t('choose_language'),"showBackButton":_setup.showBackButton,"size":_setup.size},on:{"back":function($event){return _vm.$emit('back')}}},[_c('ComposedListLanguagesSwitch',{staticClass:"languages-wrapper",attrs:{"variant":"with-icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }